import { useState, useEffect } from "react";
import "./Register.css";
import { API_URL } from "../utils/constants";
import { showToast } from "../utils/toast";
import PasswordInput from "../Components/PasswordInput";
import OrganizationTypeSelect from "../Components/OrganizationTypeSelect";

const Register = ({ switchForm }) => {
  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [fullName, setFullName] = useState("");
  const [organization, setOrganization] = useState("");
  const [organizationType, setOrganizationType] = useState("");

  const resetErrorState = () => {
    setTimeout(() => {
      setMessage("");
      setIsError(false);
    }, 3000);
  };

  useEffect(() => {
    if (message) {
      showToast(message, { type: isError ? "error" : "success" });
    }
  }, [message, isError]);

  const handleRegister = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setMessage("Passwords do not match");
      setIsError(true);
      resetErrorState();
      return;
    }
    if (!organizationType) {
      setMessage("Please select your organization type");
      setIsError(true);
      resetErrorState();
      return;
    }
    try {
      const sendObject = JSON.stringify({
        email,
        password,
        fullName,
        organization,
        organizationType,
      });

      const response = await fetch(`${API_URL}/users/register`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: sendObject,
      });
      const data = await response.json();
      if (response.status === 200) {
        showToast("Account created. Please sign in.", { type: "success" });
        switchForm("login");
        // await fetch("http://localhost:4243/create-checkout-session",
        // {
        //   method: "POST",
        //   headers: {
        //     "Content-Type": "application/json",
        //   },

        // },
        // ).then(response2 => response2.json())
        // .then(data => {

        // window.location.href = data;
        // });
      } else {
        setMessage(data.message);
        setIsError(true);
        resetErrorState();
      }
    } catch (error) {
      setMessage(error.message);
      setIsError(true);
      resetErrorState();
    }
  };

  return (
    <div className="min-h-full flex-col bg-gradient-custom">
      <div className="flex min-h-dvh flex-1 flex-col justify-center px-6 py-12 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-sm flex flex-col items-center gap-2 sm:gap-3">
          <img
            src="logo192.png"
            alt="Seymour Logo"
            className="mx-auto h-11 sm:h-20 w-auto rounded-full"
          />
          <h1 className="text-center text-4xl sm:text-5xl font-extrabold text-white atkinson-font">
            Seymour Events
          </h1>
          <h2 className="text-center text-lg font-extrabold text-white">
            Real-time Captions and Translation
          </h2>
          <p className="mt-6 sm:mt-8 text-center text-white atkinson-font w-full">
            Already have an account?{" "}
            <span
              className="border-b cursor-pointer hover:text-indigo-500"
              onClick={() => {
                switchForm("login");
              }}
            >
              Sign in.
            </span>
          </p>
        </div>
        <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-xl">
          <form onSubmit={handleRegister} className="space-y-6 mx-4">
            <div>
              <label
                htmlFor="fullName"
                className="block text-2xl font-bold text-white text-left atkinson-font"
              >
                Full Name
              </label>
              <div className="mt-2">
                <input
                  id="fullName"
                  name="fullName"
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                  required
                  autoComplete="name"
                  placeholder="Enter your name"
                  className="block w-full rounded-md border border-[#FFFFFFCC] py-2 px-3 bg-[#595959] text-[#FFFFFF] text-sm placeholder:text-[#FFFFFFCC] placeholder:text-gray-400 focus:border-[#FFFFFF]"
                />
              </div>
            </div>

            <div className="mt-2">
              <label
                htmlFor="organization"
                className="block text-2xl font-bold text-white text-left atkinson-font"
              >
                Organization Name
              </label>
              <div className="mt-2">
                <input
                  id="organization"
                  name="organization"
                  value={organization}
                  onChange={(e) => setOrganization(e.target.value)}
                  required
                  placeholder="Enter your organization’s name"
                  className="block w-full rounded-md border border-[#FFFFFFCC] py-2 px-3 bg-[#595959] text-[#FFFFFF] text-sm placeholder:text-[#FFFFFFCC] placeholder:text-gray-400 focus:border-[#FFFFFF]"
                />
              </div>
            </div>

            <div className="mt-2">
              <OrganizationTypeSelect
                value={organizationType}
                onChange={setOrganizationType}
                buttonClassName="!py-2 text-sm"
              />
            </div>

            <div className="mt-2">
              <label
                htmlFor="email"
                className="block text-2xl font-bold text-white text-left atkinson-font"
              >
                Email
              </label>
              <div className="mt-2">
                <input
                  id="email"
                  name="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoComplete="email"
                  placeholder="Enter your email address"
                  className="block w-full rounded-md border border-[#FFFFFFCC] py-2 px-3 bg-[#595959] text-[#FFFFFF] text-sm placeholder:text-[#FFFFFFCC] placeholder:text-gray-400 focus:border-[#FFFFFF]"
                />
              </div>
            </div>

            <div className="mt-2">
              <label
                htmlFor="password"
                className="block text-2xl font-bold text-white text-left atkinson-font"
              >
                Password
              </label>
              <div className="mt-2">
                <PasswordInput
                  id="password"
                  name="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  autoComplete="new-password"
                  placeholder="Enter your password"
                  className="block w-full rounded-md border border-[#FFFFFFCC] py-2 px-3 bg-[#595959] text-[#FFFFFF] text-sm placeholder:text-[#FFFFFFCC] placeholder:text-gray-400 focus:border-[#FFFFFF]"
                />
              </div>
            </div>

            <div className="mt-2">
              <label
                htmlFor="confirmPassword"
                className="block text-2xl font-bold text-white text-left atkinson-font"
              >
                Confirm Password
              </label>
              <div className="mt-2">
                <PasswordInput
                  id="confirmPassword"
                  name="confirmPassword"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                  autoComplete="new-password"
                  placeholder="Re-enter your password"
                  className="block w-full rounded-md border border-[#FFFFFFCC] py-2 px-3 bg-[#595959] text-[#FFFFFF] text-sm placeholder:text-[#FFFFFFCC] placeholder:text-gray-400 focus:border-[#FFFFFF]"
                />
              </div>
            </div>

            <div>
              <button
                type="submit"
                className="flex w-full justify-center rounded-md !bg-[#5701AE] p-2 text-base font-semibold text-white hover:!bg-[#7A2FD3]"
                style={{ border: "2px solid #6A6680" }}
              >
                Create Account
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Register;
